import { render, staticRenderFns } from "./Resim.vue?vue&type=template&id=0d9c746a&scoped=true&"
import script from "./Resim.vue?vue&type=script&lang=js&"
export * from "./Resim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9c746a",
  null
  
)

export default component.exports